import { CompanyDto, Language, LicenseeDto } from 'app/shared-components/Types/Utils';

export interface User {
  email: string;
  id: string;
  name: string;
  roleId: string;
  leads: number;
  createdAt: Date;
  lastSignedIn: Date;
  licensee: LicenseeDto;
  licenseeId: number;
  licenseeCode: string;
  title: string;
  phone: string;
  shortToken: string;
  password: string;
  passwordConfirm: string;
  workPhone: string;
  workEmail: string;
  paymentHandle: string;
  paymentNotes: string;
  payPercentage: number;
  contactType: number;
  referralCompany: number;
  referralCompanyId: number;
  salesLevel: number;
  salesGroup: string;
  maxLeeds: number;
  paymentHandleRoles: string;
  skip: boolean;
  dripActive: boolean;
  description: string;
  apiKey: string;
  role?: { id: string; name: string };
  company: CompanyDto;
}

export interface CreateUserResponseResult {
  id: string;
}

export type AddUserRequestPayload = Partial<User>;

export interface GetUserResponseResult extends User {
  details: Details;
}

export interface GetUserLogoResponseResult {
  photoURL: string;
}

export interface CreateEditUserPayload {
  details: Details;
  dripActive?: boolean | null;
  email: string | null;
  licenseeId: number;
  password?: string;
  passwordConfirm?: string;
  phone?: string | null;
  roleId: string | null;
  apiKey?: string | null;
  shortToken?: string | null;
  skip?: boolean | null;
  referralCompanyId?: number | null;
  w9?: File | null;
  avatar?: File | null;
}

export interface Details {
  languageId: Language;
  paymentHandle?: string | null;
  paymentNotes?: string | null;
  workEmail?: string | null;
  workPhone?: string | null;
  contactType?: number | null;
  maxLeads?: number | null;
  paymentHandleRotes?: string | null;
  salesLevel?: number | null;
  title?: string | null;
  description?: string | null;
  name: string;
  w9Url?: string;
  payPercentage?: number | null;
}

export enum ContactTypeOptions {
  'Leasing Agent' = 1,
  'Real Estate Agent',
  'Apartment Locator',
  'Bird Dog',
}
